import { render, staticRenderFns } from "./MyBalanceAndExchangeRate.vue?vue&type=template&id=121e8256&scoped=true"
import script from "./MyBalanceAndExchangeRate.vue?vue&type=script&lang=js"
export * from "./MyBalanceAndExchangeRate.vue?vue&type=script&lang=js"
import style0 from "./MyBalanceAndExchangeRate.vue?vue&type=style&index=0&id=121e8256&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121e8256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('121e8256')) {
      api.createRecord('121e8256', component.options)
    } else {
      api.reload('121e8256', component.options)
    }
    module.hot.accept("./MyBalanceAndExchangeRate.vue?vue&type=template&id=121e8256&scoped=true", function () {
      api.rerender('121e8256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/dashboard/components/MyBalanceAndExchangeRate.vue"
export default component.exports